import type { ReactNode } from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { BottomNav } from "./BottomNav";

export function StorefrontLayout({ children, showNav = true }: { children: ReactNode; showNav?: boolean }) {
  return (
    <div className="mx-auto flex min-h-screen max-w-app flex-col bg-cream sm:my-6 sm:min-h-[calc(100vh-3rem)] sm:rounded-3xl sm:border sm:border-stone-300 sm:shadow-raised">
      <Header />
      <main className="flex-1">
        {children}
        <Footer />
      </main>
      {showNav && <BottomNav />}
    </div>
  );
}
